module.exports = __webpack_public_path__ + "img/trainingAll.d24be491.png";